<script>
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import VulnerabilityReport from '../shared/vulnerability_report/vulnerability_report.vue';
import { FILTER_PRESETS, FIELD_PRESETS } from '../shared/vulnerability_report/constants';
import VulnerabilityFindingModal from './vulnerability_finding_modal.vue';

export default {
  components: {
    VulnerabilityReport,
    VulnerabilityFindingModal,
  },
  mixins: [glFeatureFlagsMixin()],
  inject: ['pipeline', 'projectFullPath'],
  data() {
    return {
      graphqlFilters: undefined,
      selectedFinding: undefined,
    };
  },
  computed: {
    fieldsToShow() {
      return this.glFeatures.vulnerabilityReportTypeScannerFilter
        ? FIELD_PRESETS.PIPELINE
        : FIELD_PRESETS.PIPELINE_LEGACY;
    },
  },
  methods: {
    // Two issues here for the pipeline GraphQL endpoint:
    // 1. Severity and reportType filters, unlike for vulnerabilities, need to be lower case.
    // 2. Empty array returns an empty result, so we need to pass undefined in that case.
    normalizeForGraphQLQuery(filter) {
      return filter?.length ? filter.map((s) => s.toLowerCase()) : undefined;
    },
    transformFilters(filters) {
      return {
        ...filters,
        reportType: this.normalizeForGraphQLQuery(filters.reportType),
        severity: this.normalizeForGraphQLQuery(filters.severity),
      };
    },
    showModal(finding) {
      this.selectedFinding = finding;
    },
    hideModal() {
      this.selectedFinding = undefined;
    },
  },
  filtersToShow: FILTER_PRESETS.PIPELINE,
};
</script>

<template>
  <div>
    <vulnerability-report
      :fields="fieldsToShow"
      :filter-dropdowns="$options.filtersToShow"
      :filter-fn="transformFilters"
      @vulnerability-clicked="showModal"
    />

    <vulnerability-finding-modal
      v-if="selectedFinding"
      :finding-uuid="selectedFinding.id"
      :pipeline-iid="pipeline.iid"
      :branch-ref="pipeline.sourceBranch"
      :project-full-path="projectFullPath"
      @hidden="hideModal"
    />
  </div>
</template>
